// Formato unico de erro da API: { error: { code, message } }.
import { z } from "zod";
export const API_ERROR_CODES = [
    "VALIDATION_ERROR",
    "UNAUTHENTICATED",
    "FORBIDDEN",
    "NOT_FOUND",
    "INVALID_CREDENTIALS",
    "RATE_LIMITED",
    "CONTEST_NOT_RUNNING",
    "CONTEST_INVALID_TRANSITION",
    "CONTEST_LOCKED",
    "PROBLEM_NOT_VISIBLE",
    "SOURCE_CODE_TOO_LARGE",
    "SOURCE_CODE_EMPTY",
    "CONFLICT",
    "INTERNAL_ERROR",
];
export const apiErrorSchema = z.object({
    error: z.object({
        code: z.enum(API_ERROR_CODES),
        message: z.string(),
        /** Presente apenas em RATE_LIMITED. */
        retryAfterSeconds: z.number().int().nonnegative().optional(),
    }),
});
//# sourceMappingURL=errors.js.map